export class MenuItemToggle {
    group = '';
    selected = false;
}
